import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';

// 查询帐户余额
export function getBalance(id: string) {
    return http
        .get<{
            available: number | null; // 可用余额
            current: number | null; // 当前余额和可用余额的区别在于当前余额包含了在途资金变动，如果available返回null则可以使用current代替
        }>(API.TRADE.funding.getBalance(), {
            params: {
                plaid_account_id: id,
                customer_id: security.currentCustomerId,
                account_id: security.currentAccountId
            }
        })
        .then(({ data }) => data);
}

// 帐户凭证刷新
export function refreshCard(id: string) {
    return http
        .get<{
            public_token: string;
        }>(API.TRADE.funding.refreshCard(), {
            params: {
                plaid_account_id: id,
                customer_id: security.currentCustomerId,
                account_id: security.currentAccountId
            }
        })
        .then(({ data }) => data);
}
